import React from 'react';
import DBCheckbox from "../../../../../component/global/DBCheckbox";
import {numberWithCommas} from "../../../../../utils/methods";

function BuyVolumeItem(props) {
  const {
    classNameContainer,
    classNameTitle,
    classNamePrice,
    classNameUnit,
    title,
    price = '',
    unit,
    onClick,
    checked
  } = props

  return (
    <div className={classNameContainer}>
      <div className={classNameTitle}>
        {title}
      </div>
      <div className={classNamePrice}>
        {numberWithCommas(`${price}`)}
      </div>
      <div className={classNameUnit}>
        {unit}
      </div>
      <DBCheckbox
        onClick={onClick}
        checked={checked}
      />
    </div>
  );
}

export default BuyVolumeItem;
